// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import configureStore from './store';
import { Provider } from 'react-redux';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/analytics';
import ReactDOM from 'react-dom/client';
import env from './utils/env';
import App from './containers/App/App';

let store = null;

if (!firebase.apps.length) {
  firebase.initializeApp(JSON.parse(process.env.REACT_APP_FIREBASE_CREDS));

  if (env.isProduction) {
    firebase.analytics();
  }

  if (process.env.REACT_APP_FIRESTORE_EMULATOR_HOST) {
    const db = firebase.firestore();
    const [host, port] = String(
      process.env.REACT_APP_FIRESTORE_EMULATOR_HOST,
    ).split(':');
    db.useEmulator(host, parseInt(port));
  }

  if (process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST) {
    firebase
      .auth()
      .useEmulator(
        `http://${process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST}/`,
      );
  }

  if (window.__STORAGE_EMU_HOST__) {
    const storage = firebase.storage();
    const [host, port] = String(window.__STORAGE_EMU_HOST__).split(':');
    storage.useEmulator(host, parseInt(port));
  }
}

store = configureStore();
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // TODO: check ts error
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
);

if (env.isDevelopment) {
  window.store = store;
}
